import React, { FC  } from 'react';

import closeIcon from "../../../assets/icons/deleteStrengthCard.svg";

import { ICard } from "../../../interfaces";
import { ChallengeCardReadOnly, SolutionCardReadOnly, StrengthCardReadOnly } from '../../molecules';

interface ISolutionQuestion {
    solution: ICard,
    question: ICard,
    dilemma: ICard
}
interface ModalProps {
    chosenSolutions: ISolutionQuestion[];
    selectedStrengthCard?: any;
    close(): void;
}

const Modal: FC<ModalProps> = (props) => {
    const { close, chosenSolutions, selectedStrengthCard } = props;

    const renderSolutionsCards = () => {
        return chosenSolutions.map((card: ISolutionQuestion, index: number) => {
            return (
                <div className="order_divs_side_by_side" style={{ width: "100%" }} key={index}>
                    <div className="card_read_only_wrapper_celebration modal_card_padding">
                        <ChallengeCardReadOnly cardData={card.dilemma} />
                    </div>
                    <div className="card_read_only_wrapper_celebration modal_card_padding">
                        <SolutionCardReadOnly cardData={card.solution} />
                    </div>
                </div>
            )
        })
    }

    const gradientWhiteLineForModal = () => {
        return (
            <div className="gradient_line_holder center_horizontally_and_vertically">
                <div className="linear_gradient_line_horizontal" style={{ width: "40vw" }}></div>
            </div>
        )
    }

    const renderPeekingStrengthCard = () => {
        return( 
            <div className="strength_card_in_modal_wrapper"> 
                <div className="center_horizontally_and_vertically">
                    <div className="move_strength_to_left">
                        <div className="strength_card_in_modal">
                            
                            <div className="strength_card_read_only_modal_wrapper">
                                <StrengthCardReadOnly cardData={selectedStrengthCard} isSmall={true} />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }

    return (
        <React.Fragment>
            <div className="modal__overlay">
                <div className="modal__wrapper">
                    
                    {renderPeekingStrengthCard()}
                    
                    {gradientWhiteLineForModal()}

                    <div className="modal__content custom_scrollbar custom_made_scrollbar_for_modal" >
                        <img className="icon_x" src={closeIcon} onClick={close} alt="icon x" />

                        <div style={{ width: "100%" }}>
                            {renderSolutionsCards()}
                        </div>

                    </div>

                    {gradientWhiteLineForModal()}

                </div>
            </div>
        </React.Fragment>
    );
};

export default Modal;